import rules from "../rules/manufacture_rules.json";

export type StepKey = "throw" | "trim" | "attach_handle" | "glaze" | string;
type Baseline = { minutes: number };

export function baselineMinutes(productType: string | null, step: StepKey): Baseline | null {
  const pt = productType || "Mug";
  const rs: any = (rules as any)[pt];
  if (!rs) return null;

  const buckets = rs.sizeBuckets || [];
  const b = buckets[Math.min(1, Math.max(0, Math.floor((buckets.length - 1) / 2)))] || buckets[0];
  if (!b) return null;

  switch (step) {
    case "throw": return { minutes: Math.round(b.throwMin) };
    case "trim": return { minutes: Math.round(b.trimMin) };
    case "attach_handle": return { minutes: Math.round(b.handleMin ?? 3) };
    case "glaze": return { minutes: Math.round(b.glazeMin) };
    default: return { minutes: 5 };
  }
}
